










import Vue from 'vue';
import { getProviderStatusIndicator } from '@/components/providers/ProviderSearchResultModel';

export default Vue.component('provider-modal', {
  name: 'ProviderModal',
  props: {
    provider: {
      type: Object,
      required: true
    }
  },
  computed: {
    providerNameLine(): string {
      let response = this.provider.firstName + ' ' + this.provider.lastName;
      response = this.provider.title ? response + ' | ' + this.provider.title : this.provider.name;
      return response;

    },
    providerAddressLine(): string {
      let addressLine = '';
      if ((this as any).provider.city && (this as any).provider.state) {
        addressLine = `${(this as any).provider.city}, ${(this as any).provider.state}`;
      }
      return addressLine;
    },
    statusIndicator(): string {
      return getProviderStatusIndicator((this as any).provider.statusId);
    }
  }
});



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/componentsReusable/ProviderItem.vue